module.exports = __webpack_public_path__ + "img/emoji-neutral-fill.ba3a3cb3.svg";